import { render, staticRenderFns } from "./words-configuration.vue?vue&type=template&id=5a0c5b62&scoped=true"
import script from "./words-configuration.vue?vue&type=script&lang=ts"
export * from "./words-configuration.vue?vue&type=script&lang=ts"
import style0 from "./words-configuration.vue?vue&type=style&index=0&id=5a0c5b62&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0c5b62",
  null
  
)

export default component.exports